import angular from 'angular';
import EmployeeFilterService from '@/shared/services/EmployeeFilterService';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').component('savedFiltersButton', {
  bindings: {
    screen: '@',
    currentFilters: '<',
    defaultFilters: '<',
    onFilterChanged: '&',
    dynamicFilters: '<',
    onDynamicFiltersChanged: '&',
  },
  controller: [
    '$timeout',
    'dialogsSvc',
    'flySvc',
    function($timeout, dialogsSvc, flySvc) {
      const ctrl = this;
      ctrl.savedFilters = [];
      ctrl.selectedFilter = null;
      ctrl.hasSavedFilters = false;
      ctrl.showReset = false;
      ctrl.previousFilters = {};

      ctrl.reloadSavedFilters = function() {
        ctrl.savedFilters = EmployeeFilterService.getScreenFilters(ctrl.screen)
          .map(x => ({
            ...x,
            // Parse json and apply them to the default filters (in case there is a new filter)
            filter: { ...(ctrl.defaultFilters || {}), ...(JSON.parse(x.json) || {}) },
          }))
          .sort(dynamicSort('name'));
        ctrl.hasSavedFilters = ctrl.savedFilters.length > 0;
        if (ctrl.selectedFilter && ctrl.selectedFilter.id)
          ctrl.selectedFilter = ctrl.savedFilters.find(x => x.id === ctrl.selectedFilter.id);

        ctrl.calculateViewProps(true);
      };

      ctrl.calculateViewProps = function(force) {
        const currentJson = JSON.stringify(ctrl.currentFilters);
        //Set helper props to use in template
        if (force || currentJson !== JSON.stringify(ctrl.previousFilters)) {
          //Only do these checks if the filters have changed

          ctrl.showReset = currentJson !== JSON.stringify(ctrl.defaultFilters);

          if (ctrl.selectedFilter && currentJson !== JSON.stringify(ctrl.selectedFilter.filter)) {
            //Clear selected filter if the current filter doesn't match
            ctrl.selectedFilter = null;
          }

          if (!ctrl.selectedFilter && ctrl.showReset) {
            //Try finding matching filter
            ctrl.selectedFilter = ctrl.savedFilters.find(
              x => currentJson === JSON.stringify(x.filter),
            );
          }
          ctrl.previousFilters = { ...ctrl.currentFilters };
        }
        ctrl.dynamicFiltersAllSelected = !(ctrl.dynamicFilters || []).some(x => !x.selected);
      };
      ctrl.selectFilter = function(filter) {
        if (!filter) return;
        ctrl.selectedFilter = filter;
        ctrl.onFilterChanged({ $filters: { ...filter.filter } });
      };
      ctrl.resetFilters = function() {
        ctrl.onFilterChanged({ $filters: { ...ctrl.defaultFilters } });
      };
      ctrl.saveFilter = function() {
        dialogsSvc
          .showStringInput(
            'SearchCriteriaNameInputTitle',
            'SearchCriteriaNameInputMessage',
            'SearchCriteriaNameInputPlaceholder',
          )
          .then(function(name) {
            if (!name) return;
            EmployeeFilterService.setFilter({
              screen: ctrl.screen,
              name,
              json: JSON.stringify(ctrl.currentFilters),
            }).then(filter => {
              if (filter) {
                $timeout(() => {
                  flySvc.changesSaved();
                  ctrl.reloadSavedFilters();
                  ctrl.selectedFilter = ctrl.savedFilters.find(x => x.id === filter.id);
                }, 0);
              }
            });
          });
      };
      ctrl.deleteFilter = function(filter, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        if (!filter || !filter.id) return;
        if (ctrl.selectedFilter && ctrl.selectedFilter.id === filter.id) {
          ctrl.selectedFilter = null;
        }
        EmployeeFilterService.deleteFilter(filter).then(() => {
          $timeout(() => {
            flySvc.changesSaved();
            ctrl.reloadSavedFilters();
          }, 0);
        });
      };
      ctrl.replaceFilter = (filter, $event) => {
        $event.stopPropagation();
        $event.preventDefault();
        if (!filter || !filter.id) return;
        const model = {
          ...filter,
          json: JSON.stringify(ctrl.currentFilters),
        };
        EmployeeFilterService.setFilter(model).then(updatedFilter => {
          if (updatedFilter) {
            $timeout(() => {
              flySvc.changesSaved();
              ctrl.reloadSavedFilters();
            }, 0);
          }
        });
      };
      ctrl.renameFilter = function(filter, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        if (!filter || !filter.id) return;
        dialogsSvc
          .showStringInput(
            'SearchCriteriaNameInputTitle',
            'SearchCriteriaNameInputMessage',
            'SearchCriteriaNameInputPlaceholder',
            filter.name,
          )
          .then(function(name) {
            if (!name) return;
            const model = { ...filter, name };
            EmployeeFilterService.setFilter(model).then(updatedFilter => {
              if (updatedFilter) {
                $timeout(() => {
                  flySvc.changesSaved();
                  ctrl.reloadSavedFilters();
                }, 0);
              }
            });
          });
      };
      ctrl.toggleAllDynamicFilters = function() {
        const selected = !ctrl.dynamicFiltersAllSelected;

        const dynamicFilters = ctrl.dynamicFilters.map(x => {
          if (!selected && !angular.equals(ctrl.currentFilters[x.id], ctrl.defaultFilters[x.id])) {
            return { ...x, selected: true }; // Keep used filter on screen
          }
          return { ...x, selected };
        });

        ctrl.onDynamicFiltersChanged({ $filters: dynamicFilters });
      };
      ctrl.toggleDynamicFilter = function(filter) {
        const selected = filter.selected;
        const dynamicFilters = ctrl.dynamicFilters.map(x => {
          if (x.id === filter.id) return { ...x, selected };
          return x;
        });
        ctrl.onDynamicFiltersChanged({ $filters: dynamicFilters });
        if (
          !selected &&
          !angular.equals(ctrl.currentFilters[filter.id], ctrl.defaultFilters[filter.id])
        ) {
          // Reset filter when it's removed
          ctrl.onFilterChanged({
            $filters: { ...ctrl.currentFilters, [filter.id]: ctrl.defaultFilters[filter.id] },
          });
        }
      };
      ctrl.$doCheck = function() {
        ctrl.calculateViewProps();
      };
      EmployeeFilterService.load().then(function() {
        //Wrap in timeout because the promise doesn't run in angular context
        $timeout(() => {
          ctrl.reloadSavedFilters();
        }, 0);
      });
    },
  ],
  template: `<div class="btn-group save-filters">
    <button type="button" class="btn btn-default" ng-show="!$ctrl.hasSavedFilters && $ctrl.showReset" ng-click="$ctrl.saveFilter()">
      <i class="glyphicon glyphicon-floppy-disk"></i>
      <span data-translate>SaveSearchCriteria</span>
    </button>
    <div class="btn-group" ng-show="$ctrl.hasSavedFilters">
      <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-search" ng-class="{'text-success':!!$ctrl.selectedFilter.id,'text-orange':$ctrl.showReset && !$ctrl.selectedFilter}"></i>
        <span data-translate ng-hide="$ctrl.selectedFilter.name">SelectSearchCriteria</span>
        <span ng-show="$ctrl.selectedFilter.name" ng-bind="$ctrl.selectedFilter.name"></span>
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li ng-show="$ctrl.showReset && !$ctrl.selectedFilter">
          <a href="" ng-click="$ctrl.saveFilter()">
            <i class="fa-fw glyphicon glyphicon-floppy-disk"></i>
            <span data-translate>SaveSearchCriteria</span>
          </a>
        </li>
        <li ng-show="$ctrl.showReset">
          <a href="" ng-click="$ctrl.resetFilters()">
            <i class="fa fa-fw fa-undo"></i>
            <span data-translate>ResetFilters</span>
          </a>
        </li>
        <li role="separator" class="divider" ng-show="$ctrl.showReset"></li>
        <li ng-repeat="filter in $ctrl.savedFilters" ng-class="{active:$ctrl.selectedFilter&&$ctrl.selectedFilter.id===filter.id}">
          <a href="" ng-click="$ctrl.selectFilter(filter)">
            <span>{{filter.name}}</span>
            <i class="fa fa-exchange clickable" title="{{('ReplaceSearchCriteria'|translate)}}" ng-show="!$ctrl.selectedFilter && $ctrl.showReset" ng-click="$ctrl.replaceFilter(filter, $event)"></i>
            <i class="fa fa-pencil clickable" title="{{('RenameSearchCriteria'|translate)}}" ng-click="$ctrl.renameFilter(filter, $event)"></i>
            <i class="fa fa-trash clickable" title="{{('DeleteSearchCriteria'|translate)}}" ng-click="$ctrl.deleteFilter(filter, $event)"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="btn-group" ng-if="$ctrl.dynamicFilters.length>0">
      <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-filter"></i>
        <span data-translate="MoreFilters"></span>
        <span class="caret"></span>
      </button>
      <ul class="checkbox-list dropdown-menu">
        <li>
          <span>
            <cx-checkbox value="$ctrl.dynamicFiltersAllSelected" on-change="$ctrl.toggleAllDynamicFilters()" text="{{('SelectAll'|translate)}}">
            </cx-checkbox>
          </span>
        </li>
        <li ng-repeat="filter in $ctrl.dynamicFilters">
          <span>
            <cx-checkbox value="filter.selected" on-change="$ctrl.toggleDynamicFilter(filter)" text="{{filter.label}}">
            </cx-checkbox>
          </span>
        </li>
      </ul>
    </div>
    <button type="button" class="btn btn-default" ng-show="$ctrl.showReset" ng-click="$ctrl.resetFilters()">
      <i class="fa fa-undo"></i>
      <span data-translate>ResetFilters</span>
    </button>
  </div>`,
});
